module.exports = __webpack_public_path__ + "img/TIMES.19cc616e.svg";